import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 1.25A6.75 6.75 0 1 0 14.76 8 6.76 6.76 0 0 0 8 1.25Zm0 12V2.75a5.25 5.25 0 0 1 0 10.5Z';
const draw24px =
  'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18V4a8,8,0,0,1,0,16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ContrastIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'contrast'),
) as IconWithRender;

ContrastIcon.displayName = 'ContrastIcon';
ContrastIcon.propTypes = Icon.propTypes;
ContrastIcon.renderIcon = (props) => <ContrastIcon {...props} />;
export default ContrastIcon;
